export const ITEMS_BUFFER = 20;
export const ROW_HEIGHT = 40;
export const HEADER_HEIGHT = 50;

export const getColumnsFromConfig = (dashlet, fieldsById) => {
  return (
    dashlet?.config?.feExtraInfo?.columns
      .map((c) => {
        const field = fieldsById?.[c.id];
        if (!field) {
          return null;
        }

        return {
          ...c,
          name: field?.name,
        };
      })
      ?.filter(Boolean) ?? []
  );
};
